import { render } from "./User-C007-En.vue?vue&type=template&id=16e7e566&scoped=true"
const script = {}

import "./User-C007-En.vue?vue&type=style&index=0&id=16e7e566&scoped=true&lang=css"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e7e566"]])

export default __exports__